import { SolicitudesService } from './../../../services/solicitudes/solicitudes.service';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { Router,ActivatedRoute } from "@angular/router";
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LoginService } from 'app/services/login/login.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-nuevo-quejas-reclamos',
  templateUrl: './nuevo-quejas-reclamos.component.html',
  styleUrls: ['./nuevo-quejas-reclamos.component.scss'],
  providers:[MessagesTitles, MessagesStatus,DatePipe , {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoQuejasReclamosComponent {

  form: FormGroup;
  loading : boolean = false;

  constructor(private datePipe: DatePipe,
              private router: Router,private activateRoute :ActivatedRoute,
              private msgTitulos : MessagesTitles,
              private msgStatus:MessagesStatus,
              private loginService: LoginService,
              private solicitudService: SolicitudesService) {

                this.form = new FormGroup({
                  Codigo: new FormControl('', [Validators.required]),
                  TipoSolicitud: new FormControl({ value: "", disabled: false }),
                  TipoDocumentoIdentidad: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  NroDocumentoIdentidad: new FormControl('', [Validators.required]),
                  NombresCompletos: new FormControl('', [Validators.required]),
                  ApellidoPaterno: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  ApellidoMaterno: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  Edad: new FormControl({ value: "", disabled: false }, [Validators.required,Validators.pattern("[0-9]+$")]),
                  Direccion: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  Departamento: new FormControl('', [Validators.required]),
                  Provincia: new FormControl('',[Validators.required] ),
                  Distrito: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  TelefonoMovil: new FormControl('', [Validators.required,Validators.pattern("[0-9]+$")]),
                  Email: new FormControl({ value: "", disabled: false }, [Validators.required]),
                  Moneda: new FormControl('', ),
                  Monto: new FormControl('', ),
                  Detalle: new FormControl('',[Validators.required]),
                  Pedido: new FormControl( '', [Validators.required]),
                  Estado: new FormControl('P', []),
                  FechaRegistro: new FormControl(this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
                  Conformidad: new FormControl('S', []),
                  Canal: new FormControl('W', []),
                });             
               }

  tipoSolicitud(event){
    this.form.controls['TipoSolicitud'].setValue(event);
  }
  tipoMoneda(event){
    this.form.controls['Moneda'].setValue(event);
  }

  guardarSolicitud(){

    this.form.controls['FechaRegistro'].setValue(this.datePipe.transform(this.form.controls['FechaRegistro'].value,'yyyy-MM-dd'));
    if (this.form.controls['Edad'].value < 18){
      this.showNotification('warning','top','right','Solo registrar a mayores de edad!! ');
      return;
      } 
    if (this.form.controls['Detalle'].value == '' || this.form.controls['Pedido'].value == ''){
      this.showNotification('warning','top','right','Rellenar los campos Detalle/Pedido!! ');
      return;
      } 
    if (this.form.invalid){
     this.showNotification('warning','top','right','Verificar los campos resaltados de color rojo!! ');
     return;
     }  

     Swal.fire({
      title: "Espere",
      text: "Guardado Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
   
    this.solicitudService.guardarSolicitud(this.form.getRawValue())
    .subscribe(resp => {
      Swal.fire({
        title: "Success",
        text: "Solicitud registrado correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(res =>{
        if (res.value == true ){ 
          this.loginService.clickGuard = true;
          this.router.navigate(['/libroReclamaciones/quejasReclamos/listado']);           
        }
      });
    },(err: HttpErrorResponse)=> {
      
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);            
    }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "SOLICITUD NO GUARDADO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    });

  }


  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
